import { useState, useEffect, useRef } from "react";
import {
    TextField,
    MenuItem,
    Grid,
    Typography,
    Paper,
    FormControl,
    InputLabel,
    Select,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Box,
    useMediaQuery,
    useTheme,
    styled,
    ToggleButton,
    ToggleButtonGroup,
    //Autocomplete,
    createFilterOptions
} from "@mui/material";
import { MainContainer } from "../../components";
import { usePost, useFetchWithBody, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_CURRENCY_SETTING_VAL, ENUM_GRADDING_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_TRADEOF_CODE, getModMandatory, getModValue, linksUrl, URIEncrypt } from "../../constants/enum";
import { useNavigate, useParams } from "react-router-dom";
import { Checkbox, Input, Chip, Autocomplete, AutocompleteItem } from "@heroui/react"
import { format } from 'date-fns';
import { useSelector, useDispatch } from "react-redux";
import { resetDetail, setDetailParams } from "../../state/packetTransferSlice";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowUp, faDownload, faExclamationTriangle, faFileExcel, faPlus, faRemove, faSave, faTrash } from "@fortawesome/free-solid-svg-icons";
import { funCheckNumber } from "../../Utility/utility";
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { useModalToast } from "../../components/modalToast/ModalToastContext"

const PacketTransferEntry = () => {
    const { compCode, dbUser, isMultipleCompany, startDate, endDate } = useSelector((state) => state.company);
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useDispatch();
    const { detailParams, isNewEntry, stockPktData } = useSelector((state) => state.pktTransfer);
    const [deletedItemRows, setDeletedItemRows] = useState([]);
    const [selBarcodeSplitter, setSelBarcodeSplitter] = useState("#");
    const [isBarcode, setIsBarcode] = useState(false);
    const [entryLabel, setEntryLabel] = useState("")
    const [selBillType, setSelBillType] = useState("Q")
    const [CurrencySetting, setCurrencySetting] = useState("")
    const { strdtype, sptype } = useParams();
    const [selTradeOf, setSelTradeOf] = useState("")
    const [selPktType, setSelPktType] = useState("")
    const [naviCode, setnaviCode] = useState("")
    const [isExcelImport, setIsExcelImport] = useState(false)
    const [isImportByStockId, setIsImportByStockId] = useState(false)
    const [ExcelColMap, setExcelColMap] = useState([])
    const [excelData, setExcelData] = useState([])
     const [stockIdSplitter, setStockIdSplitter] = useState("-")
    const fileInputRef = useRef(null)
    const { show } = useModalToast()

    const { mutate: getEntryDetail, data: detail = [] } = usePost({
        queryKey: "entryDetail",
        url: apiRoute.packetTransferEntry.getEntryDetail,
    });

    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modSetting.getMultiModSetting,
        queryKey: "fetchModSettingInwardItem",
    })
    const { data: stkimpt = [], mutate: filterStockData } = usePostMutateWithSuccess({
        url: apiRoute.memoEntry.fetchStockData,
        queryKey: "fetchImportStockData",

    })
    const { data: locData = [], mutate: funChkLocation } = usePostMutateWithSuccess({
        url: apiRoute.packetTransferEntry.chkStockLocation,
        queryKey: "chkStockLocation",

    })
    // Form state with correct initial date format
    const today = dayjs();
    const [formData, setFormData] = useState({
        Ac_Id: "",
        Chal_No: "",
        From_Loc: "",
        Date: today.isAfter(dayjs(endDate))
            ? null
            : today.format("YYYY-MM-DD"), // Correct format for date input
        Purpose: "",
        To_Loc: "",
        GraddingType: ""
    });

    // Table rows state
    const [rows, setRows] = useState([]);
    const { data: excelTempData, mutate: filterXlTemplate } = usePost({
        url: apiRoute.stockEntry.getExcelTemplate,
        queryKey: "funExcelTemplateStock",

    })
    useEffect(() => {
        let modName = ''
        filterModSetting({
            data: {
                page_mod: modName,
                master_mod: ENUM_MOD_NAME.GeneralSettings
            }
        })
        filterXlTemplate({
            data: {
                tempname: 'MemoImport'
            }
        })
    }, [])
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)

        const params = [URIEncrypt.Polish, URIEncrypt.Rough]
        if (!params.includes(String(strdtype))
            || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(sptype))
            navigate(linksUrl.dashboard.tradingDashboard)

        if (strdtype && strdtype != "" && sptype && sptype != "" && startDate && startDate != "" && startDate != null && endDate && endDate != "" && endDate != null) {
            let t_tradeof = ''
            let t_entryLabel = ''
            let t_pktType = ''
            let t_trdtype = strdtype.toLowerCase()

            if (sptype == URIEncrypt.SinglePacket)
                t_pktType = 'SNG'
            else
                t_pktType = 'MIX'

            if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Polish
                t_entryLabel = "Polish "
                setnaviCode(linksUrl.packetTrasnferEntry.polishStock)
            }
            else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rough
                t_entryLabel = "Rough "
                setnaviCode(linksUrl.packetTrasnferEntry.roughStock)
            }


            setSelTradeOf(t_tradeof)
            setEntryLabel(t_entryLabel)
            setSelPktType(t_pktType)

            if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
                getEntryDetail(
                    {
                        data: {
                            compcode: compCode,
                            billtype: selBillType,
                            transactionid: detailParams.transaction_id,
                            tradeof: t_tradeof
                        }
                    })
            }


        }

    }, [sptype, strdtype, startDate, endDate])
    useEffect(() => {
        if (modSetting && Object.keys(modSetting).length > 0) {
            const modData = modSetting.pageData
            const generalData = modSetting.masterData
            setCurrencySetting(getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS)
            setIsBarcode(getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.Barcode, generalData) ?? false)
            setSelBarcodeSplitter(getModValue(ENUM_MOD_PARAMETER.GeneralSetting.BarcodeSplitter, generalData) ?? '#')

        }
    }, [modSetting])



    // API calls for dropdowns
    const { data: accountList = [] } = useFetchWithBody({
        url: apiRoute.packetTransferEntry.getAccount,
        queryKey: ["accountList", compCode],
        inputData: {
            compCode
        }
    });

    const { data: fromLocationList = [] } = useFetchWithBody({
        url: apiRoute.packetTransferEntry.getFromLocation,
        queryKey: ["fromLocation", compCode],
        inputData: {
            compCode
        }
    });

    const { data: toLocationList = [] } = useFetchWithBody({
        url: apiRoute.packetTransferEntry.getToLocation,
        queryKey: ["toLocation", compCode],
        inputData: {
            compCode
        }
    });

    const { data: purposeList = [] } = useFetchWithBody({
        url: apiRoute.packetTransferEntry.getPurposeList,
        queryKey: ["purposeList"],
        inputData: {
            db_user: dbUser
        }
    });
    useEffect(() => {

        if (isNewEntry && stockPktData && Object.keys(stockPktData).length > 0) {
            const { fromLocation, data } = stockPktData;
            setFormData({ ...formData, From_Loc: fromLocation })
            setIsExcelImport(false)
            setEntryLabel("Stock Transfer Entry")
            setRows(
                data.map((item, idx) => ({
                    id: idx + 1,
                    DetailId: item?.DetailId || "",
                    Lot_No: item?.l_code ?? "",
                    Pkt_No: item?.pktno ?? "",
                    Shape: item?.s_code || "",
                    Shade: item?.sha_code || "",
                    Purity: item?.q_code || "",
                    Pcs: item?.pcs ?? 0,
                    Weight: item?.bweight ?? 0,
                    Rate: item?.brate ?? 0,
                    Amount: item?.amount ?? 0,
                    CRate: item?.crate ?? 0,
                    DRate: item?.brated ?? 0,
                    DAmount: item?.amountd ?? 0,
                    Barcode: item?.l_code + selBarcodeSplitter + item?.pktno
                }))
            );
        }

    }, [stockPktData, accountList])

    useEffect(() => {

        if (!isNewEntry && detail && Object.keys(detail).length > 0) {

            const entry = detail?.itemData?.[0];
            const items = detail?.itemDetail || [];

            if (entry) {
                setFormData({
                    Ac_Id: entry.Ac_Id || "",
                    Chal_No: entry.Chal_No || "",
                    From_Loc: entry.Lac_Id || "",
                    Date: format(new Date(entry.Chal_Date), 'yyyy-MM-dd'),
                    Purpose: entry.Purpose || "",
                    To_Loc: entry.Pac_Id || "",
                    GraddingType: items.length > 0 ? items[0]?.DesignNo : "",
                });

                setRows(
                    items.map((item, idx) => ({
                        id: idx + 1,
                        DetailId: item?.DetailId || "",
                        Lot_No: item?.L_Code ?? "",
                        Pkt_No: item?.PktNo ?? "",
                        Shape: item?.S_Code ?? "",
                        Shade: item?.Sh_Code || "",
                        Purity: item?.Q_Code || "",
                        Pcs: item?.Nos ?? 0,
                        Weight: item?.Weight ?? 0,
                        Rate: item?.Rate ?? 0,
                        Amount: item?.Amount ?? 0,
                        CRate: item?.C_Rate ?? 0,
                        DRate: item?.S_Rate ?? 0,
                        DAmount: item?.AmountD ?? 0,
                        Barcode: item.L_Code + selBarcodeSplitter + item.PktNo
                    }))
                );
            }

        }
    }, [detail, accountList, detailParams]);
    // Generate Chal_No when Account is selected
    const {
        mutate: fetchChalNo,
        data: chalNoDataFromPost
    } = usePost({
        queryKey: "chalNo",
        url: apiRoute.packetTransferEntry.GenerateVouNo,
    });

    // Get stock data when Lot No and Pkt No are entered
    const {
        mutate: fetchStockData,
    } = usePost({
        queryKey: "stockData",
        url: apiRoute.packetTransferEntry.getStockData,
    });

    useEffect(() => {
        if (chalNoDataFromPost?.[0]?.new_vou_no) {
            setFormData((prev) => ({
                ...prev,
                Chal_No: chalNoDataFromPost[0].new_vou_no
            }));
        }
    }, [chalNoDataFromPost]);

    const handleChange = (e) => {
        const { name, value } = e.target;


        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

        // Trigger Chal No API call when Ac_Id changes

    };

    const handleAutoCompleteChange = (value, name) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        if (name === "Ac_Id") {
            fetchChalNo({
                data: {
                    compCode,
                    vou_type: selBillType,
                    book_id: value,
                    trade_of: selTradeOf,
                    start_date: dayjs(startDate).format("YYYY-MM-DD"),
                    end_date: dayjs(endDate).format("YYYY-MM-DD"),
                }
            });
        }
    }
    const handleAddRow = () => {
        const newRow = {
            id: rows.length + 1,
            Lot_No: "",
            Pkt_No: "",
            Shape: "",
            Shade: "",
            Purity: "",
            Pcs: 0,
            Weight: 0
        };
        setRows([...rows, newRow]);
    };
    const funcalAmount = (rate, drate, crate, weight) => {
        let t_rate = rate;
        let t_DRate = drate
        let amount = 0
        let amountD = 0
        let tempVal = 0
        if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {

            // && CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar
            if (drate != "" && drate != null && crate && crate != null) {
                tempVal = parseFloat(drate) * parseFloat(crate)
                t_rate = funCheckNumber(tempVal).toFixed(2)
            }
            else if (rate != "" && rate != null && crate && crate != null) {
                tempVal = parseFloat(t_rate) / parseFloat(crate)
                t_DRate = funCheckNumber(tempVal).toFixed(2)
            }

        }
        tempVal = parseFloat(t_rate) * parseFloat(weight)
        amount = funCheckNumber(tempVal)
        tempVal = parseFloat(t_DRate) * parseFloat(weight)
        amountD = funCheckNumber(tempVal)

        return { rate: t_rate, drate: t_DRate, amount: amount, amountD: amountD }

    }
    const funSetStockData = (LotNo, PktNo, id) => {
        if (rows.filter((ele) => ele.Lot_No == LotNo && ele.Pkt_No == PktNo && ele.id != id).length > 0) {
            toast.error("Duplicate Pkt No and Lot No not allow", {
                position: "top-center"
            })
            setRows(prevRows =>
                prevRows.map(row =>
                    row.id === id ? {
                        ...row,
                        Lot_No: "",
                        Pkt_No: "",
                        Barcode: ""
                    } : row
                )
            );
        }
        else {
            filterStockData({
                data: {
                    compcode: compCode.join(","),
                    lotno: LotNo,
                    pktno: PktNo,
                    tradeof: selTradeOf,
                    action: '',
                    // db_user: dbUser,
                    // compcode: compCode,
                    // lotno: ,
                    // pktno: PktNo,
                    // tradeof: selTradeOf
                }
            }, {
                onSuccess: (data) => {
                    funSetSNGStockData(data, id > 0 ? id - 1 : 0, rows)
                    // if (data && data[0]) { // Fixed response check
                    //     const stock = data[0];
                    //     //  const calData=funcalAmount(stock?.BRate,stock?.BRated,stock?.CRate,stock?.BWeight)
                    //     setRows(prevRows =>
                    //         prevRows.map(row =>
                    //             row.id === id ? {
                    //                 ...row,
                    //                 Shape: stock.ShapeCode || "",
                    //                 Shade: stock.ColorCode || "",
                    //                 Purity: stock.PurityCode || "",
                    //                 Pcs: stock?.BPcs ?? 0,
                    //                 Weight: stock?.BWeight ?? 0,
                    //                 Rate: stock?.BRate ?? 0,
                    //                 DRate: stock?.BRated ?? 0,
                    //                 CRate: stock?.CRate ?? 0,
                    //                 Amount: (parseFloat(stock?.BRate) * parseFloat(stock?.BWeight)).toFixed(2),
                    //                 DAmount: (parseFloat(stock?.BRated) * parseFloat(stock?.BWeight)).toFixed(2)
                    //             } : row
                    //         )
                    //     );
                    // }
                    // else {
                    //     toast.error("Stock Not Found", {
                    //         position: "top-center"
                    //     })
                    //     setRows(prevRows =>
                    //         prevRows.map(row =>
                    //             row.id === id ? {
                    //                 ...row,
                    //                 Lot_No: "",
                    //                 Pkt_No: "",
                    //                 Barcode: ""
                    //             } : row
                    //         )
                    //     );
                    // }
                },
                onError: (error) => {
                    console.error("Error fetching stock data:", error);
                }
            });
        }

    }
    const handleRowChange = (id, field, value) => {
        if (field == 'Rate' || field == 'DRate' || field == 'CRate' || field == 'Weight') {

            const newRows = [...rows]
            let index = rows.findIndex(ele => ele.id == id)
            let t_Amount = 0
            let t_DAmount = 0
            let tempVal = 0

            let t_rate = field == 'Rate' ? value : newRows[index]?.Rate ?? 0
            let t_DRate = field == 'DRate' ? value : newRows[index]?.DRate ?? 0
            const t_weight = field == 'Weight' ? value : newRows[index]?.Weight ?? 0
            let conv_rate = field == 'CRate' ? value : newRows[index]?.CRate ?? 0
            // newRows[index][field] = value
            if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {

                // && CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar
                if ((field == 'DRate' || field == 'CRate')) {
                    tempVal = parseFloat(t_DRate) * parseFloat(conv_rate)
                    t_rate = funCheckNumber(tempVal).toFixed(2)
                }
                else if ((field == 'Rate' || field == 'CRate')) {
                    tempVal = parseFloat(t_rate) / parseFloat(conv_rate)
                    t_DRate = funCheckNumber(tempVal).toFixed(2)
                }
            }

            tempVal = parseFloat(t_rate) * parseFloat(t_weight)
            t_Amount = funCheckNumber(tempVal)
            tempVal = parseFloat(t_DRate) * parseFloat(t_weight)
            t_DAmount = funCheckNumber(tempVal)



            newRows[index].Amount = t_Amount.toFixed(2)
            newRows[index].DAmount = t_DAmount.toFixed(2)
            newRows[index].Rate = t_rate
            newRows[index].DRate = t_DRate
            newRows[index].CRate = conv_rate
            newRows[index].Weight = t_weight

            setRows(newRows)

        }
        else {

            setRows(rows.map(row =>
                row.id === id ? {
                    ...row,
                    [field]: field === 'Pcs' || field === 'Weight' || field === 'Rate' || field === 'DRate' || field === 'Amount' || field === 'DAmount' ?
                        (isNaN(value) ? 0 : parseFloat(value)) : // Ensure proper number parsing
                        value
                } : row
            ));
        }

    };
    const handleBlur = (id, field, value) => {

        if (field === 'Barcode') {

            const row = rows.find(r => r.id === id);
            if (row) {
                const barcodeParts = row.Barcode.split(selBarcodeSplitter);

                if (barcodeParts.length === 2) {
                    // Fetch stock data when both Lot No and Pkt No are available
                    if (barcodeParts[0] && barcodeParts[1]) {
                        funSetStockData(barcodeParts[0], barcodeParts[1], id)
                    }
                }
            }
        }

        // Fetch stock data when both Lot No and Pkt No are manually entered
        else if (field === 'Lot_No' || field === 'Pkt_No') {
            const row = rows.find(r => r.id === id);
            if (row) {
                const currentLotNo = row.Lot_No;
                const currentPktNo = row.Pkt_No;

                if (currentLotNo != '' && currentPktNo != '') {
                    funSetStockData(currentLotNo, currentPktNo, id)
                }
            }
        }
    }

    const handleDeleteRow = (id) => {
        const deletedRow = rows.find(row => row.id === id);
        // Only track rows that were already saved (i.e., have a valid DetailId)
        if (deletedRow?.DetailId > 0) {
            funChkLocation({
                data: {
                    compcode: compCode.join(","),
                    trade_of: selTradeOf,
                    to_location: formData.To_Loc,
                    l_code: deletedRow?.Lot_No,
                    pktno: deletedRow?.Pkt_No
                },
                onSuccess: (data) => {
                    if (data && data.length > 0) {
                        show("Packet can't be delete as it locked");
                        return; // ✅ stops here
                    }

                    setDeletedItemRows(prev => [
                        ...prev,
                        { detailId: deletedRow.DetailId }
                    ]);

                    setRows(prev => prev.filter(row => row.id !== id));
                }
            });
        }
        else
            setRows(prev => prev.filter(row => row.id !== id));

    };

    const handleRemoveAll = () => {
        setRows([]);
    };

    const funGetMasterLink = () => {
        if (stockPktData && stockPktData?.data?.length > 0)
            return linksUrl.stockEntry.stockReport
        else
            return naviCode + "/" + strdtype + "/" + sptype + linksUrl.packetTrasnferEntry.entrysingleMaster
    }

    const { mutate: insertTransfer, isPending } = usePost({
        queryKey: "transferInsert",
        url: apiRoute.packetTransferEntry.InsertUpdatePktTransfer,
        // successMessage: "Transfer created successfully",
        onSuccessTasks: () => {
            setFormData({
                Ac_Id: "",
                Chal_No: "",
                From_Loc: "",
                Date: format(new Date(), 'yyyy-MM-dd'),
                Purpose: "",
                To_Loc: ""
            });
            setRows([]);
            setDeletedItemRows([]);
            navigate(naviCode + "/" + strdtype + "/" + sptype + linksUrl.packetTrasnferEntry.entrysingleMaster);
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        // Prepare payload with proper data types
        const payload = {
            comp_code: parseInt(compCode),
            bill_type: selBillType,
            trade_of: selTradeOf,
            login_userid: user.username,
            rec_status: isNewEntry ? 2 : 1, // 2 for insert, 1 for update
            trans_id: isNewEntry ? 0 : detailParams?.transaction_id || 0,
            ac_id: formData.Ac_Id.toString(),
            vou_no: formData.Chal_No.toString(),
            chal_no: formData.Chal_No.toString(),
            chal_date: formData.Date,
            to_location: formData.To_Loc.toString(),
            from_location: formData.From_Loc.toString(),
            purpose: formData.Purpose,
            gradding_type: formData.Purpose == 'Lab Issue' ? formData.GraddingType : "",
            fystart_date: dayjs(startDate).format("YYYY-MM-DD"),
            fyend_date: dayjs(endDate).format("YYYY-MM-DD"),
            pkt_type: 'SNG',
            item_list: rows.map(row => ({
                detailId: row.DetailId || 0,
                lotNo: row.Lot_No?.toString() || "",
                pktNo: row.Pkt_No?.toString() || "",
                shapeCode: row.Shape?.toString() || "",
                colorCode: row.Shade?.toString() || "",
                purityCode: row.Purity?.toString() || "",
                pcs: row?.Pcs ?? 0,
                weight: row?.Weight ?? 0,
                rate: row?.Rate ?? 0,
                amount: row?.Amount ?? 0,
                dRate: row?.DRate ?? 0,
                dAmount: row?.DAmount ?? 0,
                convRate: row?.CRate ?? 0

            })),
            deleteditem_list: deletedItemRows
        };

        if (payload.item_list.length === 0) {
            show("Please add at least one item");
            return;
        }

        insertTransfer({ data: payload });
    };

    const setCurrencyColumnVisiblity = (column) => {
        const RsCol = ['Rate', 'Amount']
        const DCol = ['DRate', 'DAmount', 'CRate']
        if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL)
            return true
        else
            return false
    }

    const handleClickPrev = () => {
        navigate(funGetMasterLink())
    }

    const cellStyle = {
        '& .MuiInputBase-root': {
            height: 35, // set your desired height
            fontSize: '0.80rem', // reduce font size
            width: 100
        },
        '& .MuiInputBase-input': {
            padding: '4px 8px',
        },
    }
    const funSetSNGStockData = (data, index, rowData) => {

        if (data && data.length > 0) {
            const newRows = [...rowData]// [...rows]
            //let index = selectedGridRowId


            newRows[index]["Lot_No"] = data[0].LotNo
            newRows[index]["Pkt_No"] = data[0].PktNo
            newRows[index]["Shape"] = data[0].ShapeCode
            newRows[index]["Shade"] = data[0].ColorCode
            newRows[index]["Purity"] = data[0].PurityCode
            newRows[index]["Pcs"] = data[0]?.BPcs
            newRows[index]["Weight"] = data[0]?.BWeight
            newRows[index]["Rate"] = data[0]?.BRate ?? 0
            newRows[index]["DRate"] = data[0]?.BRated ?? 0
            newRows[index]["CRate"] = data[0]?.CRate ?? 0
            newRows[index]["Amount"] = (parseFloat(data[0]?.BRate) * parseFloat(data[0]?.BWeight)).toFixed(2)
            newRows[index]["DAmount"] = (parseFloat(data[0]?.BRated) * parseFloat(data[0]?.BWeight)).toFixed(2)
            if (isBarcode)
                newRows[index]["Barcode"] = data[0].LotNo + selBarcodeSplitter + data[0].PktNo

            setRows(newRows)
        }
        else {
            const newRows = [...rowData]


            //let index = selectedGridRowId
            newRows[index]["Lot_No"] = ""
            newRows[index]["Pkt_No"] = ""
            newRows[index]["Shape"] = ""
            newRows[index]["Shade"] = ""
            newRows[index]["Purity"] = ""
            newRows[index]["Pcs"] = 0
            newRows[index]["Weight"] = 0
            if (isExcelImport) {
                const updatedRows = newRows.filter((ele) => ele.Lot_No != '' && ele.Pkt_No != '')
                const rearrangedRows = updatedRows.map((row, index) => {

                    return {
                        ...row,
                        id: index + 1, // Reassign IDs to start from 1 again
                    }
                })

                setRows(rearrangedRows)
            }
            else
                setRows(newRows)

            if (!toast.isActive("toast_stock")) {
                toast.error("Stock Not Found", {
                    "position": "top-center",
                    "className": "toast-error",
                    toastId: "toast_stock"
                })
            }
        }
    }
    const handleCheckChange = (value) => {
        setIsExcelImport(value)
        if (!value)
            setRows([])
    }
    const handleImportByStockId = (value) => {
        setIsImportByStockId(value)
        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Clear file input
        }
        setRows([])
    }
    const handleSellTypeUpload = (dataRows) => {
        const getColNo = (colName) =>
            excelTempData.find(ele => ele.tb_col_name === colName)?.xl_col_no;

        const L_Colno = getColNo('l_code');
        const Pkt_Colno = getColNo('pktno');
        const Stkid_Colno = getColNo('stoneid');

        if (!L_Colno || !Pkt_Colno) {
            toast.error("Missing column mapping for Lot No or Pkt No", {
                position: "top-center",
                toastId: "colMap",
            });
            return;
        }
        const funGetLotNPktNoByStockID = (stockID = "") => {
            const resultData = { l_code: "", pktno: "" };

            const showToast = (id, msg) => {
                if (toast && !toast.isActive(id)) {
                    toast.error(msg, {
                        position: "top-center",
                        className: "toast-error",
                        toastId: id,
                    });
                }
            };

            const resetFileInput = () => {
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            };

            if (!stockID.trim()) {
                return resultData;
            }

            const [lotNo, pktNo] = stockID.split( stockIdSplitter || '-');

            if (lotNo && pktNo) {
                resultData.l_code = lotNo.trim();
                resultData.pktno = pktNo.trim();
            } else {
                show(`Invalid StockID Format: LotNo & PktNo must be separated by  '${stockIdSplitter || '-'} '`);
                resetFileInput();
            }

            if (!resultData.l_code || !resultData.pktno) {
                showToast("stkinkval", "StockID not found or invalid format");
                resetFileInput();
            }

            return resultData;
        };

        const mappedData = dataRows.map((row) => {
            const l_code = row[L_Colno - 1] ?? "";
            const pktno = row[Pkt_Colno - 1] ?? "";

            if (isImportByStockId) {
                const stockid = row[Stkid_Colno - 1] ?? "";
                return funGetLotNPktNoByStockID(stockid);
            }

            return { l_code, pktno };
        }).filter(row => row.l_code || row.pktno);

        const newRows = mappedData.map((ele, ind) => ({
            id: ind + 1,
            Lot_No: ele.l_code,
            Pkt_No: ele.pktno,
            Shape: "",
            Shade: "",
            Purity: "",
            Pcs: 0,
            Weight: 0
        }));

        if (!newRows.length) return;

        setRows(newRows);

        mappedData.forEach((item, index) => {
            // setSelectedGridRowId(index);
            filterStockData({
                data: {
                    compcode: compCode.join(","),
                    lotno: item.l_code,
                    pktno: item.pktno,
                    tradeof: selTradeOf,
                    action: '',
                },
                onSuccess: (data) => {

                    funSetSNGStockData(data, index, newRows);
                    if (data?.length <= 0) {
                        setExcelColMap(prev => [
                            ...prev,
                            { msg: `lot No : ${item.l_code} & Pkt No : ${item.pktno}` },
                        ]);

                    }



                }
            });
        });
    };
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        setExcelColMap([]); // Reset column map before reading

        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            if (!rows?.length) return;

            const dataRows = rows.slice(1);
            const headers = rows[0]; // Not used here but might be needed elsewhere


            handleSellTypeUpload(dataRows);
        }

        reader.readAsBinaryString(file);

        // Reset file input so re-selecting same file triggers onChange
        e.target.value = null;
    };

    const handleErrors = () => {
        if (ExcelColMap.length === 0) return;

        const fullMessage = ExcelColMap.map((ele) => {
            return selBillType === 'P'
                ? `• ${ele.msg}`
                : `•  ${ele.msg}`;
        }).join('\n');

        toast.warning(`${selBillType === 'P' ? ' Duplicate Lot No & Pkt No Not Allowed : ' : 'Stock Not Found For : '}  \n ${fullMessage}`, {
            position: "top-center",
            className: "text-sm whitespace-pre-line p-2  text-gray-700", // preserve line breaks
            toastId: "excel-warnings",
            icon: false // single toast ID to prevent duplicates
        });

    }
    const [inputValue, setInputValue] = useState("");
    const filterOptions = (options, { inputValue }) => {
        const search = inputValue.toLowerCase().trim();

        const filtered = options.filter((option) =>
            option.Party_Name?.toLowerCase().includes(search)
        );

        // Sort: best matches first
        return filtered.sort((a, b) => {
            const aName = a.Party_Name.toLowerCase();
            const bName = b.Party_Name.toLowerCase();

            const aStarts = aName.startsWith(search);
            const bStarts = bName.startsWith(search);

            // Priority 1: startsWith match
            if (aStarts && !bStarts) return -1;
            if (!aStarts && bStarts) return 1;

            // Priority 2: shorter distance (closer match)
            return aName.indexOf(search) - bName.indexOf(search);
        });
    };
    const handleDownloadExcel = () => {
        // File: ExportExcel.js
        // Define headersif()

        const data = [...excelTempData];

        const sortedData = data.sort((a, b) => Number(a.xl_col_no) - Number(b.xl_col_no));

        const headers = sortedData.map(ele => ele.xl_col_name)
        //if (headers && headers.length > 0) {
        //  Create a worksheet with headers only
        const ws = XLSX.utils.aoa_to_sheet([headers]);

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate Excel file buffer
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        // Trigger download with FileSaver
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        saveAs(blob, "PacketTrasferUploadFormat.xlsx");


    }
    const headerStyle = { backgroundColor: "#f3f3f3", fontWeight: 600 }
    return (
        <MainContainer
            pageName={`${isNewEntry ? "New" : "Update"} ${entryLabel}   Packet Transfer Entry - Single`}
            breadcrumbs={[entryLabel, "Packet Transfer", "Single"]}
            prevPage={{
                show: true,
                onClick: handleClickPrev
            }}
        >
            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ fontSize: '1rem', fontWeight: 'bold', mb: 1 }}>
                    Packet Transfer Entry
                </Typography>

                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        {/* Account Dropdown */}
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth size={isMobile ? 'small' : 'medium'}>
                                {/* <InputLabel>Account *</InputLabel>
                                <Select
                                    name="Ac_Id"
                                    value={formData.Ac_Id || ""}
                                    onChange={handleChange}
                                    size={'small'}
                                    required
                                    label="Account *"
                                >
                                    {accountList?.map((account) => (
                                        <MenuItem key={account.Party_Id} value={account.Party_Id?.toString()}>
                                            {account.Party_Name}
                                        </MenuItem>
                                    ))}
                                </Select> */}
                                <Autocomplete
                                    isRequired
                                    size="sm"
                                    radius="sm"
                                    color={"danger"}
                                    name={"Ac_Id"}
                                    variant="bordered"
                                    eventResizeFeature={true}
                                    selectionMode="single"
                                    showScrollIndicators={true}
                                    placeholder="-Select-"
                                    label="Account"
                                    className="w-full text-xs"
                                    classNames={{
                                        base: "min-h-[24px]",
                                        title: "text-xs",
                                        input: "text-xs",
                                    }}
                                    menuTrigger={"input"}
                                    isClearable={false}
                                    //isLoading={isLoadingData}
                                    isVirtualized
                                    defaultItems={
                                        accountList || []
                                    }
                                    onSelectionChange={(e) =>
                                        handleAutoCompleteChange(e, "Ac_Id")}
                                    selectedKey={formData.Ac_Id}
                                >
                                    {(item) => (
                                        <AutocompleteItem
                                            key={item.Party_Id}
                                            classNames={{
                                                base: "min-h-[24px] ",
                                                title: "text-xs whitespace-normal break-words",
                                            }}

                                        >
                                            {item.Party_Name}
                                        </AutocompleteItem>
                                    )}
                                </Autocomplete>
                            </FormControl>

                        </Grid>

                        {/* Chal No */}
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="Chal No"
                                name="Chal_No"
                                value={formData.Chal_No || ""}
                                onChange={handleChange}
                                required
                                disabled
                                size={'small'}
                            />
                        </Grid>

                        {/* From Location */}
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth size={isMobile ? 'small' : 'medium'}>



                                <Autocomplete
                                    isRequired
                                    size="sm"
                                    radius="sm"
                                    color={"danger"}
                                    name={"From_Loc"}
                                    variant="bordered"
                                    eventResizeFeature={true}
                                    selectionMode="single"
                                    showScrollIndicators={true}
                                    placeholder="--Select--"
                                    label="From Location"
                                    isReadOnly={isNewEntry ? false : true}
                                    className="w-full text-xs"
                                    classNames={{
                                        base: "min-h-[24px]",
                                        title: "text-xs",
                                        input: "text-xs",
                                    }}
                                    menuTrigger={"input"}
                                    isClearable={false}
                                    //isLoading={isLoadingData}
                                    isVirtualized
                                    defaultItems={
                                        fromLocationList || []
                                    }
                                    onSelectionChange={(e) =>
                                        handleAutoCompleteChange(e, "From_Loc")}
                                    //onChange={handleFormSelectionChange}
                                    selectedKey={formData.From_Loc}
                                >
                                    {(item) => (
                                        <AutocompleteItem
                                            key={item.Party_Id}
                                            classNames={{
                                                base: "min-h-[24px]",
                                                title: "text-xs whitespace-normal break-words",
                                            }}

                                        >
                                            {item.Party_Name}
                                        </AutocompleteItem>
                                    )}
                                </Autocomplete>
                                {/* <Autocomplete
                                    size="small"
                                    options={fromLocationList || []}
                                    getOptionLabel={(option) => option.Party_Name || ""}
                                    isOptionEqualToValue={(option, value) =>
                                        String(option.Party_Id) === String(value?.Party_Id)
                                    }
                                    value={
                                        fromLocationList?.find(
                                            (loc) => String(loc.Party_Id) === String(formData.From_Loc)
                                        ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        handleChange({
                                            target: {
                                                name: "From_Loc",
                                                value: newValue ? newValue.Party_Id.toString() : "",
                                            },
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="From Location "
                                            required
                                        />
                                    )}
                                /> */}
                            </FormControl>
                        </Grid>

                        {/* Date */}
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="Date"
                                type="date"
                                name="Date"
                                value={formData.Date || ""}
                                onChange={handleChange}
                                required
                                InputLabelProps={{ shrink: true }}
                                size={'small'}
                                inputProps={{
                                    max: format(new Date(), 'yyyy-MM-dd')
                                }}
                            />
                        </Grid>

                        {/* Purpose */}
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth size={isMobile ? 'small' : 'medium'}>
                                <InputLabel>Purpose *</InputLabel>
                                <Select
                                    name="Purpose"
                                    value={formData.Purpose || ""}
                                    onChange={handleChange}
                                    required
                                    label="Purpose *"

                                    size={'small'}
                                >
                                    {purposeList?.map((purpose) => (
                                        <MenuItem key={purpose.PurposeName} value={purpose.PurposeName.toString()}>
                                            {purpose.PurposeName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* To Location */}
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth size={isMobile ? 'small' : 'medium'}>
                                <Autocomplete
                                    isRequired
                                    size="sm"
                                    radius="sm"
                                    color={"danger"}
                                    name={"To_Loc"}
                                    label="To Location "
                                    variant="bordered"
                                    eventResizeFeature={true}
                                    selectionMode="single"
                                    showScrollIndicators={true}
                                    placeholder="-Select-"
                                    className="w-full text-sm"
                                    classNames={{
                                        base: "min-h-[24px] py-0",
                                        title: "text-md",
                                        input: "text-xs",

                                    }}
                                    menuTrigger={"input"}
                                    isClearable={false}
                                    //isLoading={isLoadingData}
                                    isReadOnly={isNewEntry ? false : true}
                                    isVirtualized
                                    defaultItems={
                                        toLocationList || []
                                    }
                                    onSelectionChange={(e) =>
                                        handleAutoCompleteChange(e, "To_Loc")}
                                    //onChange={handleFormSelectionChange}
                                    selectedKey={formData.To_Loc}
                                >
                                    {(item) => (
                                        <AutocompleteItem
                                            key={item.Party_Id}
                                            classNames={{
                                                base: "min-h-[24px] py-1",
                                                title: "text-xs whitespace-normal break-words",
                                            }}

                                        >
                                            {item.Party_Name}
                                        </AutocompleteItem>
                                    )}
                                </Autocomplete>
                                {/* <Autocomplete
                                    size="small"
                                    options={toLocationList || []}
                                    getOptionLabel={(option) => option.Party_Name || ""}
                                    isOptionEqualToValue={(option, value) =>
                                        String(option.Party_Id) === String(value?.Party_Id)
                                    }
                                    value={
                                        toLocationList?.find(
                                            (loc) => loc.Party_Id?.toString() === String(formData.To_Loc)
                                        ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        handleChange({
                                            target: {
                                                name: "To_Loc",
                                                value: newValue ? newValue.Party_Id.toString() : "",
                                            },
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="To Location "
                                            required
                                        />
                                    )}
                                /> */}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth size={isMobile ? 'small' : 'medium'}>
                                <InputLabel>Grading Type *</InputLabel>
                                <Select
                                    name="GraddingType"
                                    value={formData.GraddingType || ""}
                                    onChange={handleChange}
                                    required={formData.Purpose == 'Lab Issue' ? true : false}
                                    disabled={formData.Purpose == 'Lab Issue' ? false : true}
                                    label="GraddingType *"
                                    size={'small'}
                                >
                                    {ENUM_GRADDING_TYPE?.map((list) => (
                                        <MenuItem key={list.key} value={list.value}>
                                            {list.value}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Add Row Button */}
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<FontAwesomeIcon icon={faPlus} />}
                                onClick={handleAddRow}
                                sx={{ mr: 2 }}
                            >
                                Add Row
                            </Button>
                            {isNewEntry && stockPktData && stockPktData?.data?.length <= 0 &&
                                (
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        startIcon={<FontAwesomeIcon icon={faRemove} />}
                                        onClick={handleRemoveAll}
                                    >
                                        Clear All
                                    </Button>
                                )}
                        </Grid>
                    </Grid>
                    <div className="mb-2">

                        <div className="flex justify-end gap-2 items-center my-2 px-5 ">
                            {/* {CurrencySetting = ENUM_CURRENCY_SETTING_VAL.DUAL ? */}

                            {
                                isNewEntry && stockPktData && stockPktData?.data?.length <= 0 ?
                                    <>
                                        <Checkbox size="sm"
                                            classNames={{ "label": "text-white " }}
                                            className="py-1 px-2 rounded-md bg-green-800 border-blue-200 text-rose-700 border-0" label="gfu" color={"success"} isSelected={isExcelImport}
                                            onValueChange={(e) => handleCheckChange(e)}>
                                            <FontAwesomeIcon className="mr-2" icon={faFileExcel} ></FontAwesomeIcon>
                                            Import From Excel</Checkbox>
                                        {isExcelImport ? <div>
                                            <Button
                                                variant="contained"
                                                color="secondary"

                                                onClick={handleDownloadExcel}
                                                //disabled={isPending}
                                                size="small"
                                                sx={{
                                                    fontSize: "0.6rem",
                                                    marginLeft: "5px"
                                                }}
                                                startIcon={<FontAwesomeIcon icon={faDownload} />}

                                            >
                                                Upload Excel Format
                                            </Button>
                                            {/* <Button size="sm" auto color="warning" onClick={handleDownloadExcel} className="ml-4 text-sm"
                                            startContent={<FontAwesomeIcon icon={faDownload}
                                             />} >
                                            Stock Upload Excel Format
                                        </Button> */}
                                            <Checkbox size="sm"
                                                classNames={{ "label": "text-rose-700 " }}
                                                className=" py-1 px-2 ml-2  rounded-md bg-pink-100 border-blue-200 text-rose-700 border-0" label="gfu"
                                                color={"danger"} isSelected={isImportByStockId}
                                                onValueChange={handleImportByStockId}>
                                                <FontAwesomeIcon className="mr-2" icon={faCircleArrowUp} ></FontAwesomeIcon>
                                                Import By Stock ID</Checkbox></div>

                                            : ""}
                                        {isExcelImport && isImportByStockId ?
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: "0.8rem",
                                                        fontWeight: 600,
                                                        color: "#be079c"
                                                    }}
                                                >
                                                    StockId Splitter:
                                                </Typography>

                                                <ToggleButtonGroup
                                                    value={stockIdSplitter}
                                                    exclusive
                                                    onChange={(e, val) => val && setStockIdSplitter(val)}
                                                    size="small"
                                                    color="secondary"
                                                    sx={{
                                                        height: 25,

                                                        '& .MuiToggleButton-root': {
                                                            px: 1.5,
                                                            py: 0.1,
                                                            fontSize: "1.1rem",
                                                            fontWeight: 600,
                                                            textTransform: "none",
                                                            border: '1px solid #be079c',
                                                            borderRadius: 0
                                                        },

                                                        // vertical divider
                                                        '& .MuiToggleButton-root:not(:last-of-type)': {
                                                            borderRight: '1px solid #be079c'
                                                        },

                                                        '& .Mui-selected': {
                                                            backgroundColor: '#800471 !important',
                                                            color: '#ffffff !important',

                                                            '&:hover': {
                                                                backgroundColor: '#840675b1'
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <ToggleButton value="#">#</ToggleButton>
                                                    <ToggleButton value="-">-</ToggleButton>
                                                </ToggleButtonGroup>
                                            </Box> : ""}
                                    </>
                                    : ""}

                        </div>

                        {isNewEntry && isExcelImport ?
                            <div className=" p-2">
                                <div >
                                    <Input type="file" color="success" size="md" variant="flat"
                                        ref={fileInputRef}
                                        // className="w-1/2"
                                        classNames={{ label: "text-lg text-slate-700 font-semibold" }}
                                        // isRequired={isExcelImport}
                                        label="Import From Excel" accept=".xlsx, .xls" onChange={handleFileUpload} ></Input>
                                </div>
                                <div className="">
                                    {ExcelColMap && ExcelColMap.length > 0 ? (
                                        <Chip className="m-2  bg-red-200 text-red-700" onClick={handleErrors} >
                                            <FontAwesomeIcon className="mr-2" icon={faExclamationTriangle}></FontAwesomeIcon>
                                            warnings</Chip>
                                        // ExcelColMap.map((ele, index) => (
                                        //     <h5 className="text-xs text-red-700" key={index}>
                                        //         {selBillType == 'P' ? "Duplicate Lot No & Pkt No. Not Allow : " : "Stock Not Found For : "} <span className="text-green-500">{ele.msg}</span></h5>
                                        // ))

                                    ) : null}
                                </div>
                                {/* <h2 className="text-xs p-2 text-gray-300">{`In Excel Lot No Must Be In Column  ${ExcelColMap[0]?.lcode || " "}  & PktNo Must Be In Column:${ExcelColMap[0]?.pktno || " "} `}</h2> : ""} */}
                            </div> : ""}
                    </div>
                    {/* Table Section */}
                    {rows.length > 0 && (
                        <Paper elevation={3} sx={{ p: 3, overflowX: 'auto' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 1 }}>
                                    Total Items : {rows.length}
                                </Typography>
                            </Box>
                            <div className="max-h-[500px] overflow-auto border-1 border-gray-700">
                                <table className="w-full border-collapse text-xs">
                                    <thead>
                                        <tr className="bg-gray-800 text-white sticky top-0 z-10">
                                            <th className="border px-2 py-1">No#</th>
                                            <th className="border px-2 py-1">Action</th>

                                            {isBarcode && <th className="border px-2 py-1">Barcode</th>}

                                            <th className="border px-2 py-1">Lot No</th>
                                            <th className="border px-2 py-1">Pkt No</th>

                                            {!isMobile && (
                                                <>
                                                    <th className="border px-2 py-1">Shape</th>
                                                    <th className="border px-2 py-1">Shade</th>
                                                    <th className="border px-2 py-1">Purity</th>
                                                </>
                                            )}

                                            <th className="border px-2 py-1">Pcs</th>
                                            <th className="border px-2 py-1">Weight</th>

                                            {setCurrencyColumnVisiblity("DRate") && (
                                                <th className="border px-2 py-1">Rate($)</th>
                                            )}
                                            {setCurrencyColumnVisiblity("DAmount") && (
                                                <th className="border px-2 py-1">Amount($)</th>
                                            )}
                                            {setCurrencyColumnVisiblity("CRate") && (
                                                <th className="border px-2 py-1">Conv Rate</th>
                                            )}
                                            {setCurrencyColumnVisiblity("Rate") && (
                                                <th className="border px-2 py-1">Rate</th>
                                            )}
                                            {setCurrencyColumnVisiblity("Amount") && (
                                                <th className="border px-2 py-1">Amount</th>
                                            )}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {rows.map((row, index) => (
                                            <tr key={row.id} className="hover:bg-gray-50">
                                                <td className="border px-2 py-1 text-center font-medium">
                                                    {index + 1}
                                                </td>
                                                {/* ACTION */}
                                                <td className="border px-1 py-1 text-center">
                                                    <Chip
                                                        variant="light"
                                                        onClick={() => handleDeleteRow(row.id)}
                                                        className="cursor-default"
                                                    >
                                                        <FontAwesomeIcon className=" hover:bg-red-600 hover:text-white px-2 py-1 rounded text-xs text-red-700" icon={faTrash}></FontAwesomeIcon>
                                                    </Chip>
                                                </td>

                                                {/* BARCODE */}
                                                {isBarcode && (
                                                    <td className="border px-1 py-1">
                                                        <input
                                                            value={row.Barcode || ""}
                                                            onChange={(e) =>
                                                                handleRowChange(row.id, "Barcode", e.target.value)
                                                            }
                                                            placeholder={`PA ${selBarcodeSplitter}1`}
                                                            onBlur={(e) =>
                                                                handleBlur(row.id, "Barcode", e.target.value)
                                                            }
                                                            className="w-full border border-gray-300 rounded px-1 py-1 focus:outline-none focus:ring-1 focus:ring-blue-400"
                                                        />
                                                    </td>
                                                )}

                                                {/* LOT NO */}
                                                <td className="border px-1 py-1">
                                                    <input
                                                        value={row.Lot_No || ""}
                                                        onChange={(e) =>
                                                            handleRowChange(row.id, "Lot_No", e.target.value)
                                                        }
                                                        onBlur={(e) =>
                                                            handleBlur(row.id, "Lot_No", e.target.value)
                                                        }
                                                        className="w-full border border-gray-300 rounded px-1 py-1 focus:outline-none focus:ring-1 focus:ring-blue-400"
                                                    />
                                                </td>

                                                {/* PKT NO */}
                                                <td className="border px-1 py-1">
                                                    <input
                                                        value={row.Pkt_No || ""}
                                                        onChange={(e) =>
                                                            handleRowChange(row.id, "Pkt_No", e.target.value)
                                                        }
                                                        onBlur={(e) =>
                                                            handleBlur(row.id, "Pkt_No", e.target.value)
                                                        }
                                                        className="w-full border border-gray-300 rounded px-1 py-1 focus:outline-none focus:ring-1 focus:ring-blue-400"
                                                    />
                                                </td>

                                                {/* OPTIONAL FIELDS */}
                                                {!isMobile && (
                                                    <>
                                                        <td className="border px-1 py-1">
                                                            <input
                                                                value={row.Shape || ""}
                                                                onChange={(e) =>
                                                                    handleRowChange(row.id, "Shape", e.target.value)
                                                                }
                                                                className="w-full border border-gray-300 rounded px-1 py-1"
                                                            />
                                                        </td>

                                                        <td className="border px-1 py-1">
                                                            <input
                                                                value={row.Shade || ""}
                                                                onChange={(e) =>
                                                                    handleRowChange(row.id, "Shade", e.target.value)
                                                                }
                                                                className="w-full border border-gray-300 rounded px-1 py-1"
                                                            />
                                                        </td>

                                                        <td className="border px-1 py-1">
                                                            <input
                                                                value={row.Purity || ""}
                                                                onChange={(e) =>
                                                                    handleRowChange(row.id, "Purity", e.target.value)
                                                                }
                                                                className="w-full border border-gray-300 rounded px-1 py-1"
                                                            />
                                                        </td>
                                                    </>
                                                )}

                                                {/* PCS */}
                                                <td className="border px-1 py-1">
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        value={row.Pcs}
                                                        onChange={(e) =>
                                                            handleRowChange(row.id, "Pcs", e.target.value)
                                                        }
                                                        className="w-full border border-gray-300 rounded px-1 py-1"
                                                    />
                                                </td>

                                                {/* WEIGHT */}
                                                <td className="border px-1 py-1">
                                                    <input
                                                        type="number"
                                                        step="0.001"
                                                        value={row.Weight}
                                                        onChange={(e) =>
                                                            handleRowChange(row.id, "Weight", e.target.value)
                                                        }
                                                        className="w-full border border-gray-300 rounded px-1 py-1"
                                                    />
                                                </td>

                                                {/* DRATE */}
                                                {setCurrencyColumnVisiblity("DRate") && (
                                                    <td className="border px-1 py-1">
                                                        <input
                                                            type="number"
                                                            step="0.001"
                                                            value={row.DRate}
                                                            onChange={(e) =>
                                                                handleRowChange(row.id, "DRate", e.target.value)
                                                            }
                                                            className="w-full border border-gray-300 rounded px-1 py-1"
                                                        />
                                                    </td>
                                                )}

                                                {/* DAMOUNT */}
                                                {setCurrencyColumnVisiblity("DAmount") && (
                                                    <td className="border px-1 py-1">
                                                        <input
                                                            type="number"
                                                            step="0.001"
                                                            value={row.DAmount}
                                                            onChange={(e) =>
                                                                handleRowChange(row.id, "DAmount", e.target.value)
                                                            }
                                                            className="w-full border border-gray-300 rounded px-1 py-1"
                                                        />
                                                    </td>
                                                )}

                                                {/* CRATE */}
                                                {setCurrencyColumnVisiblity("CRate") && (
                                                    <td className="border px-1 py-1">
                                                        <input
                                                            type="number"
                                                            step="0.001"
                                                            value={row.CRate}
                                                            onChange={(e) =>
                                                                handleRowChange(row.id, "CRate", e.target.value)
                                                            }
                                                            className="w-full border border-gray-300 rounded px-1 py-1"
                                                        />
                                                    </td>
                                                )}

                                                {/* RATE */}
                                                {setCurrencyColumnVisiblity("Rate") && (
                                                    <td className="border px-1 py-1">
                                                        <input
                                                            type="number"
                                                            step="0.001"
                                                            value={row.Rate}
                                                            onChange={(e) =>
                                                                handleRowChange(row.id, "Rate", e.target.value)
                                                            }
                                                            className="w-full border border-gray-300 rounded px-1 py-1"
                                                        />
                                                    </td>
                                                )}

                                                {/* AMOUNT */}
                                                {setCurrencyColumnVisiblity("Amount") && (
                                                    <td className="border px-1 py-1">
                                                        <input
                                                            type="number"
                                                            step="0.001"
                                                            value={row.Amount}
                                                            onChange={(e) =>
                                                                handleRowChange(row.id, "Amount", e.target.value)
                                                            }
                                                            className="w-full border border-gray-300 rounded px-1 py-1"
                                                        />
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Summary and Submit Button */}
                            <Box sx={{ mt: 3, textAlign: "center" }}>

                                <Button
                                    variant="contained"
                                    color="secondary"
                                    type="submit"
                                    // onClick={handleSubmit}
                                    disabled={isPending}
                                    size="small"
                                    startIcon={<FontAwesomeIcon icon={faSave} />}

                                >
                                    {isPending ? "Submitting..." : "Submit"}
                                </Button>
                            </Box>
                        </Paper>
                    )}
                </form>
            </Paper>

        </MainContainer>
    );
};

export default PacketTransferEntry;